import { Image, Text } from '@oy/ui';
import { Colors } from '@oy/uicore';
import { useUITranslate } from '../../../../../hooks/useUITranslate';
import React from 'react';
import styles from './ErrorRetrieveData.module.css';

export const ErrorRetrieveData = () => {
  const { translate } = useUITranslate();
  return (
    <div className={styles.container}>
      <Image name="illustration_notInternet" />
      <Text textStyle={Text.Style.HeadingMd}>
        {translate('Failed To Load Title')}
      </Text>
      <Text textStyle={Text.Style.BodyLgRegular} color={Colors.BLACK40}>
        {translate('Failed To Load Description')}
      </Text>
    </div>
  );
};
